var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lb"},[_c('div',{ref:"barMian",staticClass:"barMian"})])
}
var staticRenderFns = []

export { render, staticRenderFns }